import { Grid, MenuItem, TextField, useMediaQuery, useTheme } from '@mui/material';

interface SelectProps {
  options: { label: string; value: string }[];
  onChange(value: string): void;
  value: string;
}

export interface LockerUtilisationChartHeaderProps {
  hubSelect: SelectProps;
  groupingSelect: SelectProps;
  dateRangeSelect: SelectProps;
}

export function LockerUtilisationChartHeader({
  dateRangeSelect,
  groupingSelect,
  hubSelect
}: LockerUtilisationChartHeaderProps) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid
      container
      style={{ fontSize: '16px' }}
      sx={{
        justifyContent: 'space-between',
        alignItems: isXs ? 'flex-start' : 'center'
      }}
    >
      <Grid
        container
        spacing={2}
        size={{
          sm: 8,
          xs: 6
        }}
      >
        <Grid style={{ width: isXs ? '100%' : undefined }}>
          <TextField
            style={{ width: isXs ? '100%' : '180px' }}
            variant="outlined"
            select
            size="small"
            value={hubSelect.value}
            onChange={(e) => hubSelect.onChange(e.target.value)}
          >
            {hubSelect.options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid style={{ width: isXs ? '100%' : undefined }}>
          <TextField
            style={{ width: isXs ? '100%' : '180px' }}
            variant="outlined"
            select
            size="small"
            value={groupingSelect.value}
            onChange={(e) => groupingSelect.onChange(e.target.value)}
          >
            {groupingSelect.options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid
        container
        size={{
          sm: 4,
          xs: 6
        }}
        sx={{
          justifyContent: 'flex-end'
        }}
      >
        <TextField
          style={{ width: isXs ? '100%' : '150px' }}
          variant="outlined"
          select
          size="small"
          value={dateRangeSelect.value}
          onChange={(e) => dateRangeSelect.onChange(e.target.value)}
        >
          {dateRangeSelect.options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
}
